import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=2fab10cc&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=2fab10cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab10cc",
  null
  
)

export default component.exports